/* src/app/pages/ui-kit/components/toggle-button-view/toggle-button-view.component.scss */
.toggle-button-view {
  padding: 1rem;
}
.toggle-button-view h3 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}
.toggle-button-view h3:first-of-type {
  margin-top: 1rem;
}
.toggle-button-view .toggle-buttons-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
/*# sourceMappingURL=toggle-button-view.component.css.map */
